<template>
	<div class="clinicalCases">
		<div class="clinicalCasesBox">
			<indexTitle :title="dataInfo.moduleTitle" :more="showMore" @goMore="goMore"></indexTitle>
			<div class="listWrap">
				<div @click="$openUrl(firstData.jump_url)" class="leftOne">
					<div class="videoBox">
						<img :src="firstData.cover" alt="" />
						<img class="play" src="@/assets/index/playBtn.png" alt="" />
					</div>
					<div class="cardBottom">
						<div class="leftTitle">
							{{ firstData.title }}
						</div>
						<div class="leftFoot">
							<div class="tagBox">
								<div v-for="(tag, index) in firstData.tags" :key="index" class="tagItem">{{ tag.content
									}}
								</div>
							</div>
							<div class="date">{{ firstData.date }}</div>
						</div>
					</div>

				</div>
				<div class="rightWrap">
					<div @click="$openUrl(item.jump_url)" :key="item.id" v-for="item in threeList"
						class="rightListItem">
						<div class="left_video">
							<img :src="item.cover" alt="" />
							<img class="play" src="@/assets/index/playBtn.png" alt="" />
						</div>
						<div class="rightDetail">
							<div class="title">{{ item.title }}</div>
							<div class="tagBox">
								<div v-for="(tag, index) in item.tags" :key="index" class="tagItem">{{ tag.content }}
								</div>
							</div>
							<div class="dateBox">{{ item.date }} </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import indexTitle from "@/components/c/indexTitle.vue"
export default {
	components: {
		indexTitle,
	},
	props: {
		dataInfo: {
			type: Object,
			default: () => {
				return {
					is_show: 0,
					list: [],
					moduleTitle: this.$t('i18n_65'),
				}
			},
		},
		showMore: {
			type: Boolean,
			default: true,
		}
	},
	computed: {
		firstData() {
			return this.dataInfo.list.length ? this.dataInfo.list[0] : {}
		},
		threeList() {
			return this.dataInfo.list.length ? this.dataInfo.list.filter((el, index) => index > 0) : []
		}
	},
	data() {
		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {
		goMore() {
			let lang = this.$i18n.locale == 'zh' ? 'cn' : 'en'
			this.$router.push({
				path: `/${lang}/cases`,
			})
		},
	}
}
</script>

<style scoped lang="scss">
.clinicalCases {
	background: #FFFFFF;
	padding-bottom: 120px;
	margin-top: 116px;

	.clinicalCasesBox {
		width: 1200px;
		margin: auto;

		.listWrap {
			display: flex;

			.leftOne {
				width: 708px;
				margin-right: 30px;
				cursor: pointer;

				.videoBox {
					width: 100%;
					height: 500px;
					position: relative;

					img {
						width: 708px;
						height: 500px;
						display: block;
						object-fit: cover;
					}

					.play {
						position: absolute;
						width: 46px;
						height: 46px;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}

				.cardBottom{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 165px;
				}

				.leftTitle {
					margin-top: 26px;
					line-height: 26px;
					height: 52px;
					font-size: 20px;
					color: #000000;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.leftFoot {
					display: flex;
					justify-content: space-between;
					align-items: flex-end;

					.tagBox {
						width: 400px;
						display: flex;
						flex-wrap: wrap;

						.tagItem {
							margin-top: 4px;
							font-size: 14px;
							color: #000000;
							width: 160px;
						}
					}

					.date {
						font-size: 14px;
						color: #000000;
						line-height: 20px;
					}
				}
			}

			.rightWrap {
				width: calc(100% - (708px + 30px));

				.rightListItem {
					margin-bottom: 31px;
					display: flex;
					cursor: pointer;

					&:nth-last-child(1) {
						margin-bottom: 0px;
					}

					.left_video {
						width: 200px;
						height: 200px;
						margin-right: 32px;
						position: relative;

						img {
							width: 200px;
							height: 200px;
							object-fit: cover;
							display: block;
						}

						.play {
							position: absolute;
							width: 46px;
							height: 46px;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}

					.rightDetail {
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.title {
							font-size: 20px;
							color: #000000;
							line-height: 24px;
							height: 72px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.tagBox {
							display: flex;
							align-items: center;
							flex-wrap: wrap;

							.tagItem {
								font-size: 14px;
								color: #000000;
								margin-bottom: 4px;
								margin-right: 12px;
							}
						}

						.dateBox {
							font-size: 14px;
							color: #000000;
							line-height: 16px;
						}
					}
				}
			}
		}
	}
}

@media screen and (max-width:1200px) {
	.clinicalCases {
		background: #FFFFFF;
		padding-bottom: 100px;

		.clinicalCasesBox {
			width: 100%;
			margin: auto;

			.listWrap {
				display: flex;
				flex-wrap: wrap;

				.leftOne {
					width: 100%;
					margin-right: 0px;

					.videoBox {
						width: 100%;
						height: 500px;
						position: relative;

						img {
							width: 100%;
							height: 500px;
							display: block;
							object-fit: cover;
						}

						.play {
							position: absolute;
							width: 46px;
							height: 46px;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}

					.leftTitle {
						margin-top: 30px;
						padding: 0 20px;
						line-height: 21px;
						height: 42px;
						font-size: 20px;
						color: #000000;
					}

					.leftFoot {
						margin-top: 21px;
						padding: 0 20px;
						display: flex;
						justify-content: space-between;
						align-items: flex-end;

						.tagBox {
							width: 400px;
							display: flex;
							flex-wrap: wrap;

							.tagItem {
								margin-top: 16px;
								font-size: 14px;
								color: #000000;
								width: 160px;
							}
						}

						.date {
							font-size: 14px;
							color: #000000;
							line-height: 20px;
						}
					}
				}

				.rightWrap {
					width: 100%;
					margin-top: 50px;

					.rightListItem {
						margin-bottom: 31px;
						display: flex;

						.left_video {
							width: 200px;
							height: 200px;
							margin-right: 32px;
							position: relative;

							img {
								width: 200px;
								height: 200px;
								object-fit: cover;
								display: block;
							}

							.play {
								position: absolute;
								width: 46px;
								height: 46px;
								left: 50%;
								top: 50%;
								transform: translate(-50%, -50%);
							}
						}

						.rightDetail {
							display: flex;
							flex-direction: column;
							justify-content: space-between;

							.title {
								font-size: 20px;
								color: #000000;
								line-height: 22px;
							}

							.tagBox {
								display: flex;
								align-items: center;
								flex-wrap: wrap;

								.tagItem {
									font-size: 14px;
									color: #000000;
									margin-bottom: 16px;
									margin-right: 12px;
								}
							}

							.dateBox {
								font-size: 14px;
								color: #000000;
								line-height: 16px;
							}
						}
					}
				}
			}
		}
	}
}
</style>
